import React from "react";
import { Link } from "react-router-dom";
import { Instagram, MapPin, Phone, MessageCircle, Star, Facebook } from "lucide-react";
import { Logo } from "./Logo";
import { useLang } from "../context/LanguageContext";
import { T } from "../i18n/translations";
import { CONTACT } from "../data/media";

export const Footer = () => {
  const { lang } = useLang();
  return (
    <footer className="relative bg-trise-blue text-trise-ivory pt-24 pb-10 grain overflow-hidden" data-testid="footer">
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid gap-14 md:grid-cols-12">
          <div className="md:col-span-5">
            <Logo dark />
            <p className="mt-6 text-xl md:text-2xl font-light max-w-sm leading-snug">
              {T.footer.tagline[lang]}
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-widen text-trise-brass mb-5">
              {T.contatti_page.hours_label[lang]}
            </h4>
            <p className="text-sm leading-relaxed text-trise-ivory/80">{T.footer.hours_short[lang]}</p>
            <address className="not-italic mt-6 flex items-start gap-3 text-sm text-trise-ivory/80">
              <MapPin size={16} className="text-trise-brass mt-0.5 shrink-0" />
              {CONTACT.address}
            </address>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-xs uppercase tracking-widen text-trise-brass mb-5">
              {T.contatti_page.social_label[lang]}
            </h4>
            <div className="flex flex-col gap-3 text-sm">
              <a href={`tel:${CONTACT.phoneTel}`} data-testid="footer-phone" className="flex items-center gap-3 hover:text-trise-brass transition-colors">
                <Phone size={16} className="text-trise-brass" /> {CONTACT.phoneDisplay}
              </a>
              <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="flex items-center gap-3 hover:text-trise-brass transition-colors">
                <MessageCircle size={16} className="text-trise-brass" /> WhatsApp
              </a>
              <a href={CONTACT.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="flex items-center gap-3 hover:text-trise-brass transition-colors">
                <Instagram size={16} className="text-trise-brass" /> @trise_bistrot
              </a>
              <a href={CONTACT.facebook} target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" className="flex items-center gap-3 hover:text-trise-brass transition-colors">
                <Facebook size={16} className="text-trise-brass" /> Facebook
              </a>
              <a href={CONTACT.tripadvisor} target="_blank" rel="noopener noreferrer" data-testid="footer-tripadvisor" className="flex items-center gap-3 hover:text-trise-brass transition-colors">
                <Star size={16} className="text-trise-brass" /> TripAdvisor
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-trise-brass/25 flex flex-col md:flex-row items-center justify-between gap-4 text-xs uppercase tracking-widen text-trise-ivory/50">
          <span>© {new Date().getFullYear()} Trisé Bistrot · {T.footer.rights[lang]}</span>
          <div className="flex gap-6">
            <Link to="/menu" className="hover:text-trise-brass transition-colors">{T.nav.menu[lang]}</Link>
            <Link to="/storia" className="hover:text-trise-brass transition-colors">{T.nav.storia[lang]}</Link>
            <Link to="/contatti" className="hover:text-trise-brass transition-colors">{T.nav.contatti[lang]}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
